// extracted by mini-css-extract-plugin
export default {"templatesContainer":"CreateAnamnesePopupContent_templatesContainer__BLlv1"};